/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useMemo, useState } from "react";
import { Box, IconButton } from "@mui/material";
import TableComponent from "../../components/TableComponent";
import { GridColDef } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import AddReply from "../../Modals/addReply";
import { SupportItem, useDeleteSupportMutation } from "../../services/customerSupport";
import moment from "moment";
import { showError, showToast } from "../../constants/toasts";
import { ConfirmationModal } from "../../Modals/ConfirmationModal";

type Props = {
  rows: SupportItem[];
  total: number;
  loading: boolean;
  statusTab?: "PENDING" | "APPROVED";
  fetchCustomerSupport?: () => void
};

const CustomerSupportList = ({ rows, total, loading, fetchCustomerSupport }: Props) => {

  const navigate = useNavigate();

  // status display only; no toggle here
  const [deleteQuery] = useDeleteSupportMutation()
  const [isloading, setIsLoading] = useState<boolean>()
  const [selectedId, setSelectedId] = useState<string>("");
  const [replyOpen, setReplyOpen] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);

  const deleteQueryApi = async (id: string) => {
    setIsLoading(true);
    try {
      const response = await deleteQuery({
        id,
      }).unwrap();
      setIsLoading(false);
      if (response?.statusCode === 200) {
        showToast(response?.message || "Query Deleted Successfully");
        fetchCustomerSupport && fetchCustomerSupport();
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
      setIsLoading(false);
    }
  };
  const columns: GridColDef<SupportItem>[] = useMemo(() => [
    {
      flex: 1,
      minWidth: 220,
      field: "userDetails",
      headerName: "User Details",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        const details = row.userDetails || {};
        const fullName = `${details.firstName || ""} ${details.lastName || ""}`.trim();
        const email = details.email || "";
        const image = details.image && details.image !== "string" ? details.image : "/static/images/user_placeholder.png";
        return (
          <div className="user_block click_action" onClick={() => navigate(`/manage-user/detail/${row._id}`)}>
            <figure>
              <img src={image} alt="" />
            </figure>
            <p><b>{fullName || "-"}</b> <span>{email}</span></p>
          </div>
        )
      }
    },
    {
      flex: 2,
      minWidth: 220,
      field: "title",
      headerName: "Query Title",
      editable: false,
      sortable: false,
    },
    {
      flex: 1,
      minWidth: 180,
      field: "phoneNumber",
      headerName: "Phone",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        const details = row.userDetails || {};
        const phone = details.phoneNumber || "-";
        return <span>{phone}</span>;
      }
    },
    {
      flex: 1,
      minWidth: 150,
      field: "createdAt",
      headerName: "Created Date",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        const dateStr = row?.createdAt ? moment(row.createdAt).format("DD MMMM YYYY") : "-";
        return <span>{dateStr}</span>;
      }
    },
    {
      minWidth: 180,
      field: "status",
      headerName: "Status",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        const isApproved = row.status === "APPROVED";
        const label = isApproved ? "resolved" : "pending";
        return (
          <div>
            {label}
          </div>
        );
      }
    },
    {
      minWidth: 100,
      field: "action",
      headerName: "Action",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="table_actions v2">
            {row.status !== "APPROVED" && (
              <Box>
              <IconButton onClick={() => handleReply(row)}>
                  <img src="/static/images/reply_icon.svg" alt="" />
                </IconButton>
              </Box>
            )}
            <Box>
              <IconButton onClick={() => {
                setSelectedId(row?._id);
                setConfirmOpen(true);
              }}>
                <img src="/static/images/trash2_icon.svg" alt="" />
              </IconButton>
            </Box>
          </div>
        )
      }
    }
  ], [navigate]);
  let hidden = ["fullName"];

 
  const [selected, setSelected] = useState<SupportItem | null>(null);
  const handleCloseModal = () => {
    setReplyOpen(false);
  };
  const handleReply = (row: SupportItem) => {
    setSelected(row);
    setReplyOpen(true);
  };

  return (
    <>
      <div className="sorting_table">
        <TableComponent
          columns={columns?.filter((item) => !hidden.includes(item.field))}
          rows={rows}
          count={total}
          loading={loading}
        />
      </div>

      <AddReply open={replyOpen} onClose={handleCloseModal} setOpen={setReplyOpen} data={selected} fetchCustomerSupport={fetchCustomerSupport} />
      <ConfirmationModal
        text={"Are you sure you want to delete this Query?"}
        openModal={confirmOpen}
        setOpenModal={setConfirmOpen}
        handleSubmit={() => deleteQueryApi(selectedId)}>

      </ConfirmationModal>
    </>
  );
};

export default CustomerSupportList;
